// src/pages/B2B/crm/components/PipelineStageBadge.tsx
import React from 'react';
import { PipelineStage } from '../api/types';

const STAGE_STYLES: Record<string, string> = {
  '1-Target': 'bg-gray-700/30 text-gray-300',
  '2-Researching': 'bg-slate-600/30 text-slate-300',
  '3-Contacted': 'bg-blue-500/20 text-blue-300',
  '4-In Conversation': 'bg-amber-500/20 text-amber-300',
  '5-Free Tier Active': 'bg-emerald-500/20 text-emerald-300',
  '6-Paid': 'bg-violet-500/30 text-violet-200',
};

export function PipelineStageBadge({ stage }: { stage: PipelineStage | null }) {
  if (!stage) return <span className="text-gray-600 text-xs">—</span>;
  const cls = STAGE_STYLES[stage] ?? 'bg-gray-700/30 text-gray-300';
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${cls}`}>
      {stage}
    </span>
  );
}
